import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import Select from "react-select";
import { Alert, Dialog, Snackbar } from "@mui/material";
import "../Candidate-Upload/candidateUpload.scss";
import TimeZone from "../../utils/all_timezones.json";
import {
  fetchVideoInterviewSlots,
  bookVideoInterviewSlot,
  getCandidateHiringStage,
} from "../../Redux/ActionCreators/jobsAction";
import { fetchTenantBranding } from "../../Redux/ActionCreators/qualifyQuestionsAction";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "../Qualify-Questions/qualifying.scss";

const CalendarIcon = ({ color = "currentColor" }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);

const GlobeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
);

const ClockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);

const ChevronDownIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);

const VideoIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="23 7 16 12 23 17 23 7"/>
    <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
  </svg>
);

const BriefcaseIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
  </svg>
);

const MailIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

const PhoneIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.77 1h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 8.91a16 16 0 0 0 5.94 5.94l.92-.92a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

export default function ScheduleVideoStage() {
  const [screenLoading, setScreenLoading] = useState(false);
  const [brandingLoading, setBrandingLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [successMessageText, setSuccessMessageText] = useState("");
  const [scheduleDate, setScheduleDate] = useState(moment());
  const [timezone, setTimezone] = useState("");
  const [slotPopupOpen, setSlotPopupOpen] = useState(false);
  const [selectedSlotId, setSelectedSlotId] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [showPhoneCheckModal, setShowPhoneCheckModal] = useState(false);
  const [linkExpired, setLinkExpired] = useState(false);
  const [linkExpiredMessage, setLinkExpiredMessage] = useState("Link has been expired");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [scheduleCompleted, setScheduleCompleted] = useState(false);

  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const { candidateHiringStage } = useSelector((state) => state.jobs);
  const availableSlots = useSelector((state) => state.jobs.availableSlots);
  const tenantBranding = useSelector(
    (state) => state.qualifyQuestions?.tenantBranding
  );
  const isWhiteLabel = Boolean(tenantBranding?.is_white_label);
  const logoSrc = isWhiteLabel && tenantBranding?.logo
    ? tenantBranding.logo
    : "/images/gappeoai-logo.png";

  useEffect(() => {
    const token = searchParams.get("t");
    if (!token) return;
    setBrandingLoading(true);
    dispatch(fetchTenantBranding(token)).finally(() => setBrandingLoading(false));
  }, [searchParams, dispatch]);

  useEffect(() => {
    if (isWhiteLabel && tenantBranding?.colour) {
      document.documentElement.style.setProperty(
        "--qualify-accent-color",
        tenantBranding.colour
      );
    }
  }, [isWhiteLabel, tenantBranding?.colour]);

  useEffect(() => {
    const fetchJob = async () => {
      if (id) {
        setScreenLoading(true);
        try {
          await dispatch(getCandidateHiringStage(id));
          await dispatch(fetchVideoInterviewSlots(id, Intl.DateTimeFormat().resolvedOptions().timeZone));
          setLinkExpired(false);
        } catch (error) {
          const status = error?.parsedStatus || error?.response?.status;
          console.error("Unexpected error", error);
          if (status === 403 || status === 410) {
            setLinkExpired(true);
            setLinkExpiredMessage("Link has been expired");
          } else if (status === 400 || status === 404) {
            setLinkExpired(true);
            setLinkExpiredMessage("Invalid link, please check and try again");
          }
        }
        setScreenLoading(false);
      }
    };
    fetchJob();

    const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const matched = TimeZone.find((tz) => tz.value === detected);
    if (matched) setTimezone(matched);
  }, [dispatch, id]);

  useEffect(() => {
    if (availableSlots.length > 0) {
      const firstDateStr = availableSlots[0].start_at_local?.substring(0, 10);
      if (firstDateStr) {
        const [year, month, day] = firstDateStr.split("-").map(Number);
        setScheduleDate(new Date(year, month - 1, day));
      }
    }
  }, [availableSlots]);

  const availableDateStrs = [...new Set(
    availableSlots.map((s) => s.start_at_local?.substring(0, 10)).filter(Boolean)
  )];
  const availableDates = availableDateStrs.map((d) => {
    const [year, month, day] = d.split("-").map(Number);
    return new Date(year, month - 1, day);
  });

  const selectedDateStr = scheduleDate ? moment(scheduleDate).format("YYYY-MM-DD") : "";
  const filteredSlots = availableSlots.filter(
    (s) => s.start_at_local?.substring(0, 10) === selectedDateStr
  );

  const slotTimeDisplay = (slot) => slot.display?.substring(11) || "";

  const slotDurationMinutes =
    availableSlots.length > 0
      ? moment(availableSlots[0].end_at_local).diff(moment(availableSlots[0].start_at_local), "minutes")
      : 15;

  const fullName = candidateHiringStage?.candidate?.name || "";
  const initials = fullName
    .split(" ")
    .filter(Boolean)
    .map((n) => n[0].toUpperCase())
    .slice(0, 2)
    .join("");

  const hiringStatus = candidateHiringStage?.status?.name?.toLowerCase();
  const isOngoingOrCompleted = hiringStatus === "ongoing" || hiringStatus === "completed";

  const handleSlotSelection = (slot) => {
    setSelectedSlotId(slot.source_slot_id);
    setSelectedSlot(slot);
    setSlotPopupOpen(false);
  };

  const handleDateChange = (date) => {
    setScheduleDate(date);
    setSelectedSlotId(null);
    setSelectedSlot(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const obj = {
      scheduled_at_utc: selectedSlot?.start_at_utc,
      scheduled_timezone: selectedSlot?.timezone,
      source_slot_id: selectedSlot?.source_slot_id,
    };

    const res = await dispatch(bookVideoInterviewSlot(id, obj));

    if (res === 200) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setSnackbarSeverity("success");
      setSuccessMessage(true);
      setSuccessMessageText("Stage scheduled and email sent successfully");
      setScheduleDate("");
      setTimezone(null);
      setScheduleCompleted(true);
    } else if (res?.success === false) {
      const message = res.message || "Something went wrong during scheduling please contact administrator";
      if (message.toLowerCase().includes("country code")) {
        setShowPhoneCheckModal(true);
        setSuccessMessageText(message);
      } else {
        setSnackbarSeverity("error");
        setSuccessMessage(true);
        setSuccessMessageText(message);
      }
    } else {
      setSnackbarSeverity("error");
      setSuccessMessage(true);
      setSuccessMessageText("Something went wrong during scheduling please contact administrator");
    }

    setLoading(false);
  };

  const snackClosed = () => {
    setSuccessMessage(false);
    setSuccessMessageText("");
  };

  const isDisabled = scheduleDate && timezone && selectedSlotId;

  if (screenLoading || brandingLoading) {
    return (
      <div className="sv-loading-screen">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <Fragment>
      <Dialog
        className="schedule-loader"
        open={loading}
        onClose={() => {}}
        PaperProps={{ sx: { boxShadow: "none" } }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Dialog>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={successMessage}
        autoHideDuration={3000}
        onClose={snackClosed}
      >
        <Alert onClose={snackClosed} severity={snackbarSeverity} sx={{ width: "100%" }}>
          {successMessageText}
        </Alert>
      </Snackbar>

      {linkExpired ? (
        <div className="sv-link-expired">{linkExpiredMessage}</div>
      ) : (
        <div className="schedule-video-page">
          <div className="schedule-video-wrapper">

            {/* Header */}
            <div className="schedule-video-header">
              <div className="d-flex justify-content-center">
                <img src={logoSrc} alt="logo" width={160} height={80} />
              </div>
              <h1 className="sv-main-title">Schedule your interview</h1>
              <p className="sv-main-subtitle">Review the details and pick a slot that works for you.</p>
            </div>

            {scheduleCompleted ? (
              <div className="schedule-card sv-thankyou-card">
                <img src="/images/thankyou-icon.gif" alt="" style={{ width: "80px", marginBottom: "16px" }} />
                <h2 style={{ marginBottom: "12px", color: "#03543F" }}>Thank you!</h2>
                <p style={{ fontSize: "18px", color: "#065F46" }}>
                  Your video interview has been scheduled successfully.
                </p>
                <p style={{ marginTop: "12px", color: "#047857" }}>
                  You may now safely close this window.
                </p>
              </div>
            ) : (
              <>
                {/* Job + Candidate Card */}
                <div className="schedule-card">
                  <div className="sv-card-top-row">
                    <span className="sv-position-badge">
                      <BriefcaseIcon />
                      POSITION
                    </span>
                    {candidateHiringStage?.job?.salary && (
                      <span className="sv-salary-top">{candidateHiringStage?.job?.salary}</span>
                    )}
                  </div>

                  <h2 className="job-card-title">{candidateHiringStage?.job?.title}</h2>
                  <p className="job-card-meta">
                    {[
                      candidateHiringStage?.job?.company_name,
                      candidateHiringStage?.job?.experience_required,
                    ].filter(Boolean).join(" · ")}
                  </p>

                  {candidateHiringStage?.job?.skills?.length > 0 && (
                    <div className="job-skills-row sv-skills-row">
                      {candidateHiringStage?.job?.skills?.slice(0, 5).map((skill, i) => (
                        <span key={i} className="skill-pill">{skill}</span>
                      ))}
                      {candidateHiringStage?.job?.skills?.length > 5 && (
                        <span className="skill-pill more-skills-pill">
                          +{candidateHiringStage?.job?.skills.length - 5} more
                          <div className="skills-popup">
                            {candidateHiringStage?.job?.skills.slice(5).map((s, idx, arr) => (
                              <span key={idx}>{s}{idx < arr.length - 1 && ", "}</span>
                            ))}
                          </div>
                        </span>
                      )}
                    </div>
                  )}

                  <div className="sv-card-divider" />

                  <div className="sv-applicant-header">
                    <div className="sv-applicant-avatar">{initials}</div>
                    <div className="sv-applicant-info">
                      <h3>{fullName}</h3>
                      <div className="sv-contact-row">
                        {candidateHiringStage?.candidate?.email && (
                          <span className="sv-contact-item">
                            <MailIcon />
                            {candidateHiringStage?.candidate?.email}
                          </span>
                        )}
                        {candidateHiringStage?.candidate?.phone && (
                          <span className="sv-contact-item">
                            <PhoneIcon />
                            {candidateHiringStage?.candidate?.phone}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Schedule Form Card */}
                <div className="schedule-card">
                  <div className="sv-form-header-row">
                    <div className="sv-form-header-icon">
                      <CalendarIcon color="#f75891" />
                    </div>
                    <div>
                      <h3 className="sv-schedule-title">Schedule Video Interview</h3>
                      <p className="sv-form-subtitle">Pick a date, time zone, and slot.</p>
                    </div>
                  </div>

                  <form onSubmit={handleSubmit} className="sv-form-fields">
                    <div className="sv-form-field">
                      <label className="sv-field-label">DATE</label>
                      <div className="sv-field-icon-wrapper">
                        <span className="sv-input-icon">
                          <CalendarIcon color="#9ca3af" />
                        </span>
                        <DatePicker
                          selected={scheduleDate?.toDate?.() || scheduleDate}
                          onChange={handleDateChange}
                          dateFormat="dd-MM-yyyy"
                          includeDates={availableDates}
                          required
                          className="sv-datepicker sv-input-with-icon"
                          placeholderText="dd-mm-yyyy"
                        />
                      </div>
                    </div>

                    <div className="sv-form-field">
                      <label className="sv-field-label">TIME ZONE</label>
                      <div className="sv-field-icon-wrapper">
                        <span className="sv-input-icon">
                          <GlobeIcon />
                        </span>
                        <Select
                          options={TimeZone}
                          value={timezone}
                          onChange={setTimezone}
                          placeholder="Select Timezone"
                          isClearable
                          className="sv-timezone-select"
                          styles={{
                            control: (base) => ({
                              ...base,
                              minHeight: "44px",
                              paddingLeft: "30px",
                              borderRadius: "8px",
                              background: "#f9fafb",
                              borderColor: "#e5e7eb",
                              boxShadow: "none",
                              width: "100%",
                              "&:hover": { borderColor: "#d1d5db" },
                            }),
                            valueContainer: (base) => ({
                              ...base,
                              padding: "0 8px",
                            }),
                            indicatorsContainer: (base) => ({
                              ...base,
                            }),
                          }}
                        />
                      </div>
                    </div>

                    <div className="sv-form-field">
                      <label className="sv-field-label">TIME SLOT</label>
                      <div className="sv-slot-dropdown" onClick={() => setSlotPopupOpen(true)}>
                        <span className="sv-input-icon-inline"><ClockIcon /></span>
                        <span className={selectedSlot ? "sv-slot-value" : "sv-slot-placeholder"}>
                          {selectedSlot ? slotTimeDisplay(selectedSlot) : "Select a time slot"}
                        </span>
                        <span className="sv-slot-chevron"><ChevronDownIcon /></span>
                      </div>
                    </div>

                    <button
                      type="submit"
                      disabled={!isDisabled || isOngoingOrCompleted}
                      className="sv-submit-btn"
                    >
                      <VideoIcon />
                      Schedule Interview
                    </button>

                    {isOngoingOrCompleted && (
                      <p className="sv-ongoing-msg">
                        Your video interview has been {hiringStatus}. You cannot schedule it again.
                      </p>
                    )}
                  </form>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {showPhoneCheckModal && (
        <div className="upload-modal">
          <div className="modal-content" style={{ width: "500px", height: "auto" }}>
            <div className="modal-head">
              <h3>Schedule Check</h3>
              <img
                src="/images/close-icon.svg"
                alt="Close"
                style={{ cursor: "pointer" }}
                onClick={() => setShowPhoneCheckModal(false)}
              />
            </div>
            <div className="modal-input" style={{ padding: "20px" }}>
              <p>{successMessageText}</p>
            </div>
            <div className="d-flex justify-content-center">
              <button className="upload-btn" onClick={() => setShowPhoneCheckModal(false)}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {slotPopupOpen && (
        <div className="slot-popup-overlay">
          <div className="slot-popup-content">
            <div className="d-flex justify-content-evenly align-items-center">
              <div className="d-flex flex-column align-items-center">
                <h4>Select a Time</h4>
                <p>Duration: {slotDurationMinutes} min</p>
              </div>
              <img
                className="cursor-pointer"
                src="/images/close.svg"
                alt="Close"
                onClick={() => setSlotPopupOpen(false)}
              />
            </div>
            <div className="slot-list">
              {filteredSlots.length === 0 ? (
                <p style={{ textAlign: "center", color: "#6B7280" }}>
                  No slots available for the selected date.
                </p>
              ) : (
                filteredSlots.map((slot, index) => (
                  <button
                    key={`${slot.source_slot_id}-${index}`}
                    className="slot-btn"
                    onClick={() => handleSlotSelection(slot)}
                  >
                    {slotTimeDisplay(slot)}
                  </button>
                ))
              )}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
